import { Dropdown } from '@design/components/dropdown/Dropdown';
import { DropdownListItem } from '@design/components/dropdown/dropdown-list-item/DropdownListItem';
import { Select } from '@design/components/select/Select';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ScheduleSelectField.module.scss';

export interface ScheduleSelectFieldProps {
  label: string;
  options: string[];
  value: string;
  translationKeyPrefix: string;
  testId: string;
  onChange: (value: string) => void;
}

export const ScheduleSelectField = ({
  label,
  options,
  value,
  translationKeyPrefix,
  testId,
  onChange,
}: ScheduleSelectFieldProps) => {
  const { t } = useTranslation(['chat']);
  const [isOpen, setIsOpen] = useState(false);

  const activeIdx = options.indexOf(value);

  const handleSelect = (item: string) => {
    onChange(item);
    setIsOpen(false);
  };

  return (
    <div className={styles.fieldGroup}>
      <label className={styles.fieldLabel} htmlFor={testId}>
        {label}
      </label>
      <Dropdown<string>
        className={styles.styledDropdown}
        dropdownItems={options}
        renderDropdownItem={(item, isActive, isFocused) => (
          <DropdownListItem
            label={t(`${translationKeyPrefix}.${item}`)}
            isActive={isActive}
            isFocused={isFocused}
          />
        )}
        selectItem={handleSelect}
        activeItemIdx={activeIdx}
        shouldShowItems={isOpen}
        onItemsShowChange={setIsOpen}
        onClick={() => setIsOpen(prev => !prev)}
        onOutsideClick={() => setIsOpen(false)}
      >
        <div className={styles.selectWrapper}>
          <Select
            isActive={isOpen}
            inputProps={{
              value: t(`${translationKeyPrefix}.${value}`),
              variant: 'outline',
              'data-testid': testId,
            }}
          />
        </div>
      </Dropdown>
    </div>
  );
};
